import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { MODAL_CLOSE } from 'redux/slices/modals';

import { Icon } from 'ui/atoms';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import { ManagePersonalData } from 'ui/components';
import {
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';

import Modal, { stopEvent } from '../Modal';

const modalId = 'editAccountData';

const EditAccountData = ({ onClose, account }) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="auto"
            type="editAccountData"
          >
            <ModalTitle>
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {t('change_personal_data')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ManagePersonalData accountData={account} />
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

EditAccountData.propTypes = {
  onClose: PropTypes.func,
  account: PropTypes.object
};

EditAccountData.id = modalId;

export default connect(null, dispatch => ({
  onClose: () => dispatch(MODAL_CLOSE())
}))(EditAccountData);
